import { PagingFilter } from '../shared/pagingFilter';

export class DepartmentsFilter extends PagingFilter {
  searchQuery: string | null;

  constructor() {
    super();
  }
}
